import styled from 'styled-components'

export const CancelInvoiceOrderReasonsWrapper = styled.div`
	font-size: 1em;
`
CancelInvoiceOrderReasonsWrapper.displayName = 'CancelInvoiceOrderReasonsWrapper'

export const CancelInvoiceOrderInputWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.63em;
	padding-bottom: 0.67em;
`
CancelInvoiceOrderInputWrapper.displayName = 'CancelInvoiceOrderInputWrapper'
